// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/registration/api/company/firstparty/v1/company.proto

/* eslint-disable */

/** Enum for address type. */
export const ApiAddressType = {
  /** ADDRESS_TYPE_UNSPECIFIED - Default or undefined journal entry type. */
  ADDRESS_TYPE_UNSPECIFIED: "ADDRESS_TYPE_UNSPECIFIED",
  /**
   * standard - Expense report journal entry.
   */
  standard: "standard",
  /**
   * headquarter - Supplier invoices journal entry.
   */
  headquarter: "headquarter",
  /**
   * operating_office - Client invoices journal entry.
   */
  operating_office: "operating_office",
} as const;

export type ApiAddressType = typeof ApiAddressType[keyof typeof ApiAddressType];

export namespace ApiAddressType {
  export type ADDRESS_TYPE_UNSPECIFIED = typeof ApiAddressType.ADDRESS_TYPE_UNSPECIFIED;
  export type standard = typeof ApiAddressType.standard;
  export type headquarter = typeof ApiAddressType.headquarter;
  export type operating_office = typeof ApiAddressType.operating_office;
}

export function apiAddressTypeFromJSON(object: any): ApiAddressType {
  switch (object) {
    case 0:
    case "ADDRESS_TYPE_UNSPECIFIED":
      return ApiAddressType.ADDRESS_TYPE_UNSPECIFIED;
    case 1:
    case "standard":
      return ApiAddressType.standard;
    case 2:
    case "headquarter":
      return ApiAddressType.headquarter;
    case 3:
    case "operating_office":
      return ApiAddressType.operating_office;
    default:
      return ApiAddressType.ADDRESS_TYPE_UNSPECIFIED;
  }
}

export function apiAddressTypeToJSON(object: ApiAddressType): string {
  switch (object) {
    case ApiAddressType.ADDRESS_TYPE_UNSPECIFIED:
      return "ADDRESS_TYPE_UNSPECIFIED";
    case ApiAddressType.standard:
      return "standard";
    case ApiAddressType.headquarter:
      return "headquarter";
    case ApiAddressType.operating_office:
      return "operating_office";
    default:
      return "ADDRESS_TYPE_UNSPECIFIED";
  }
}

/** Message for company information. */
export interface ApiCompany {
  /** Legal name of the company. */
  readonly legalName: string;
  /** Legal form of the company. */
  readonly legalForm?:
    | string
    | null
    | undefined;
  /** Legal code of the company. */
  readonly legalCode?:
    | string
    | null
    | undefined;
  /** Legal sector of the company. */
  readonly legalSector?:
    | string
    | null
    | undefined;
  /** Legal number of the company. */
  readonly legalNumber?:
    | string
    | null
    | undefined;
  /** Legal registration date of the company. */
  readonly legalRegistrationDate?:
    | string
    | null
    | undefined;
  /** Legal country of the company. */
  readonly legalCountry: string;
  /** Trade name of the company. */
  readonly tradeName?:
    | string
    | null
    | undefined;
  /** Contact email of the company. */
  readonly contactEmail: string;
  /** Activity description of the company. */
  readonly activityDescription?:
    | string
    | null
    | undefined;
  /** Website URL of the company. */
  readonly websiteUrl?:
    | string
    | null
    | undefined;
  /** List of addresses of the company. */
  readonly addresses: readonly ApiAddress[];
  /** Financial detail of the company. */
  readonly financialDetail?:
    | ApiFinancialDetail
    | null
    | undefined;
  /** Tax residence of the company. */
  readonly taxResidence?:
    | ApiTaxResidence
    | null
    | undefined;
  /** Legal TVA/VAT number of the company. */
  readonly legalTvaNumber?: string | null | undefined;
}

/** Message for address information. */
export interface ApiAddress {
  /** First line of the address. */
  readonly firstLine?:
    | string
    | null
    | undefined;
  /** Second line of the address. */
  readonly secondLine?:
    | string
    | null
    | undefined;
  /** Third line of the address. */
  readonly thirdLine?:
    | string
    | null
    | undefined;
  /** Zip code of the address. */
  readonly zipcode?:
    | string
    | null
    | undefined;
  /** City of the address. */
  readonly city?:
    | string
    | null
    | undefined;
  /** Country of the address. */
  readonly country?:
    | string
    | null
    | undefined;
  /** Type of the address. */
  readonly type: ApiAddressType;
}

/** Message for financial detail information. */
export interface ApiFinancialDetail {
  /** Estimated yearly income. */
  readonly estimatedYearlyIncome?:
    | string
    | null
    | undefined;
  /** Annual turnover. */
  readonly annualTurnover?:
    | string
    | null
    | undefined;
  /** Yearly transaction volume. */
  readonly yearlyTransactionVolume?:
    | string
    | null
    | undefined;
  /** Max single payment amount. */
  readonly maxSinglePaymentAmount?:
    | number
    | null
    | undefined;
  /** Estimated annual turnover. */
  readonly estimatedAnnualTurnover?: number | null | undefined;
}

/** Message for tax residence information. */
export interface ApiTaxResidence {
  /** Country of the tax residence. */
  readonly country?:
    | string
    | null
    | undefined;
  /** Tax identification number. */
  readonly taxIdentificationNumber?: string | null | undefined;
}

export const ApiCompany: MessageFns<ApiCompany> = {
  fromJSON(object: any): ApiCompany {
    return {
      legalName: isSet(object.legalName) ? globalThis.String(object.legalName) : "",
      legalForm: isSet(object.legalForm) ? globalThis.String(object.legalForm) : null,
      legalCode: isSet(object.legalCode) ? globalThis.String(object.legalCode) : null,
      legalSector: isSet(object.legalSector) ? globalThis.String(object.legalSector) : null,
      legalNumber: isSet(object.legalNumber) ? globalThis.String(object.legalNumber) : null,
      legalRegistrationDate: isSet(object.legalRegistrationDate)
        ? globalThis.String(object.legalRegistrationDate)
        : null,
      legalCountry: isSet(object.legalCountry) ? globalThis.String(object.legalCountry) : "",
      tradeName: isSet(object.tradeName) ? globalThis.String(object.tradeName) : null,
      contactEmail: isSet(object.contactEmail) ? globalThis.String(object.contactEmail) : "",
      activityDescription: isSet(object.activityDescription) ? globalThis.String(object.activityDescription) : null,
      websiteUrl: isSet(object.websiteUrl) ? globalThis.String(object.websiteUrl) : null,
      addresses: globalThis.Array.isArray(object?.addresses)
        ? object.addresses.map((e: any) => ApiAddress.fromJSON(e))
        : [],
      financialDetail: isSet(object.financialDetail) ? ApiFinancialDetail.fromJSON(object.financialDetail) : null,
      taxResidence: isSet(object.taxResidence) ? ApiTaxResidence.fromJSON(object.taxResidence) : null,
      legalTvaNumber: isSet(object.legalTvaNumber) ? globalThis.String(object.legalTvaNumber) : null,
    };
  },

  toJSON(message: ApiCompany): unknown {
    const obj: any = {};
    if (message.legalName !== undefined && message.legalName !== null) {
      obj.legalName = message.legalName;
    }
    if (message.legalForm !== undefined && message.legalForm !== null) {
      obj.legalForm = message.legalForm;
    }
    if (message.legalCode !== undefined && message.legalCode !== null) {
      obj.legalCode = message.legalCode;
    }
    if (message.legalSector !== undefined && message.legalSector !== null) {
      obj.legalSector = message.legalSector;
    }
    if (message.legalNumber !== undefined && message.legalNumber !== null) {
      obj.legalNumber = message.legalNumber;
    }
    if (message.legalRegistrationDate !== undefined && message.legalRegistrationDate !== null) {
      obj.legalRegistrationDate = message.legalRegistrationDate;
    }
    if (message.legalCountry !== undefined && message.legalCountry !== null) {
      obj.legalCountry = message.legalCountry;
    }
    if (message.tradeName !== undefined && message.tradeName !== null) {
      obj.tradeName = message.tradeName;
    }
    if (message.contactEmail !== undefined && message.contactEmail !== null) {
      obj.contactEmail = message.contactEmail;
    }
    if (message.activityDescription !== undefined && message.activityDescription !== null) {
      obj.activityDescription = message.activityDescription;
    }
    if (message.websiteUrl !== undefined && message.websiteUrl !== null) {
      obj.websiteUrl = message.websiteUrl;
    }
    if (message.addresses?.length) {
      obj.addresses = message.addresses.map((e) => ApiAddress.toJSON(e));
    }
    if (message.financialDetail !== undefined && message.financialDetail !== null) {
      obj.financialDetail = ApiFinancialDetail.toJSON(message.financialDetail);
    }
    if (message.taxResidence !== undefined && message.taxResidence !== null) {
      obj.taxResidence = ApiTaxResidence.toJSON(message.taxResidence);
    }
    if (message.legalTvaNumber !== undefined && message.legalTvaNumber !== null) {
      obj.legalTvaNumber = message.legalTvaNumber;
    }
    return obj;
  },
};

export const ApiAddress: MessageFns<ApiAddress> = {
  fromJSON(object: any): ApiAddress {
    return {
      firstLine: isSet(object.firstLine) ? globalThis.String(object.firstLine) : null,
      secondLine: isSet(object.secondLine) ? globalThis.String(object.secondLine) : null,
      thirdLine: isSet(object.thirdLine) ? globalThis.String(object.thirdLine) : null,
      zipcode: isSet(object.zipcode) ? globalThis.String(object.zipcode) : null,
      city: isSet(object.city) ? globalThis.String(object.city) : null,
      country: isSet(object.country) ? globalThis.String(object.country) : null,
      type: isSet(object.type) ? apiAddressTypeFromJSON(object.type) : ApiAddressType.ADDRESS_TYPE_UNSPECIFIED,
    };
  },

  toJSON(message: ApiAddress): unknown {
    const obj: any = {};
    if (message.firstLine !== undefined && message.firstLine !== null) {
      obj.firstLine = message.firstLine;
    }
    if (message.secondLine !== undefined && message.secondLine !== null) {
      obj.secondLine = message.secondLine;
    }
    if (message.thirdLine !== undefined && message.thirdLine !== null) {
      obj.thirdLine = message.thirdLine;
    }
    if (message.zipcode !== undefined && message.zipcode !== null) {
      obj.zipcode = message.zipcode;
    }
    if (message.city !== undefined && message.city !== null) {
      obj.city = message.city;
    }
    if (message.country !== undefined && message.country !== null) {
      obj.country = message.country;
    }
    if (message.type !== undefined && message.type !== null) {
      obj.type = apiAddressTypeToJSON(message.type);
    }
    return obj;
  },
};

export const ApiFinancialDetail: MessageFns<ApiFinancialDetail> = {
  fromJSON(object: any): ApiFinancialDetail {
    return {
      estimatedYearlyIncome: isSet(object.estimatedYearlyIncome)
        ? globalThis.String(object.estimatedYearlyIncome)
        : null,
      annualTurnover: isSet(object.annualTurnover) ? globalThis.String(object.annualTurnover) : null,
      yearlyTransactionVolume: isSet(object.yearlyTransactionVolume)
        ? globalThis.String(object.yearlyTransactionVolume)
        : null,
      maxSinglePaymentAmount: isSet(object.maxSinglePaymentAmount)
        ? globalThis.Number(object.maxSinglePaymentAmount)
        : null,
      estimatedAnnualTurnover: isSet(object.estimatedAnnualTurnover)
        ? globalThis.Number(object.estimatedAnnualTurnover)
        : null,
    };
  },

  toJSON(message: ApiFinancialDetail): unknown {
    const obj: any = {};
    if (message.estimatedYearlyIncome !== undefined && message.estimatedYearlyIncome !== null) {
      obj.estimatedYearlyIncome = message.estimatedYearlyIncome;
    }
    if (message.annualTurnover !== undefined && message.annualTurnover !== null) {
      obj.annualTurnover = message.annualTurnover;
    }
    if (message.yearlyTransactionVolume !== undefined && message.yearlyTransactionVolume !== null) {
      obj.yearlyTransactionVolume = message.yearlyTransactionVolume;
    }
    if (message.maxSinglePaymentAmount !== undefined && message.maxSinglePaymentAmount !== null) {
      obj.maxSinglePaymentAmount = Math.round(message.maxSinglePaymentAmount);
    }
    if (message.estimatedAnnualTurnover !== undefined && message.estimatedAnnualTurnover !== null) {
      obj.estimatedAnnualTurnover = Math.round(message.estimatedAnnualTurnover);
    }
    return obj;
  },
};

export const ApiTaxResidence: MessageFns<ApiTaxResidence> = {
  fromJSON(object: any): ApiTaxResidence {
    return {
      country: isSet(object.country) ? globalThis.String(object.country) : null,
      taxIdentificationNumber: isSet(object.taxIdentificationNumber)
        ? globalThis.String(object.taxIdentificationNumber)
        : null,
    };
  },

  toJSON(message: ApiTaxResidence): unknown {
    const obj: any = {};
    if (message.country !== undefined && message.country !== null) {
      obj.country = message.country;
    }
    if (message.taxIdentificationNumber !== undefined && message.taxIdentificationNumber !== null) {
      obj.taxIdentificationNumber = message.taxIdentificationNumber;
    }
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
